module.exports = __webpack_public_path__ + "static/media/manzate_super.fa3b378e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/tizon_tardio_tomate/preventiva/manzate_super.png
// module id = 2402
// module chunks = 3